module.exports = __webpack_public_path__ + "static/media/cart-white.8f230b9f.svg";